module.exports = __webpack_public_path__ + "static/cases-tile-3-3-df01b7a8bad97646929df719ab0c31f9.png";